/**
 * Function to send track event data to datalayer
 * @param {string} positionName String name to identify the link being clicked
 * @param {object} e Event object from the click
 */
export function handleTrackClick(positionName, e) {
  window.dataLayer.push({
    event: "linkClick",
    content: {
      title: document.title,
    },
    click: {
      href: e.currentTarget.getAttribute("href"),
      position: positionName,
    },
  });
}
